import React from 'react';
import { useNavigate } from 'react-router';
import {
  ProductContainer,
  ProductImage,
  ProductImageWrapper,
  ProductInfo,
  ProductIngress,
  ProductName,
} from './Styles';
import { ConsumerTestProductType } from '../../../../../../../../types/ConsumerTestProductType';
import { useGTMDataLayer } from '../../../../../../hooks/GTM/useGTMDataLayer';
import { useCloudinary } from '../../../../../../hooks/Cloudinary/useCloudinary';

interface Props {
  product: ConsumerTestProductType;
  category: string;
}

export const ConsumerTestProduct = ({ product, category }: Props) => {
  const { title, ingress, image, internalLink } = product;
  const navigate = useNavigate();
  const dataLayer = useGTMDataLayer();
  const { getProcessedImage } = useCloudinary();

  const itemImage = getProcessedImage(image?.public_id)?.toURL();

  if (!title) return null;

  return (
    <ProductContainer
      onClick={() => {
        const location = window?.location;
        dataLayer.push({
          event: 'link_click',
          link_text: title,
          link_location: location.pathname,
        });
        navigate(`/forbrukertester/${category}/${internalLink.slug}`);
      }}
    >
      {itemImage && image ? (
        <ProductImageWrapper>
          <ProductImage src={itemImage} alt={image?.altText || ''} />
        </ProductImageWrapper>
      ) : null}
      <ProductInfo>
        <ProductName>{title}</ProductName>
        <ProductIngress>{ingress}</ProductIngress>
      </ProductInfo>
    </ProductContainer>
  );
};
